export const routes = {
  home: '/',
  buyerDashboard: '/buyer',
  investorDashboard: '/investor',
  investorRuleOfThumb: '/investor/rule',
  about: '/about',
  contact: '/contact',
};
